import React from 'react';
import Box from '@tds/core-box';
import HairlineDivider from '@tds/core-hairline-divider';
import Paragraph from '@tds/core-paragraph';

import { ContentWrapper } from '../design/css';

const Success = () => {
  return (
    <>
      <Box between={4}>
        <HairlineDivider />
        <HairlineDivider />
      </Box>
      <div className="container 85%">
        <ContentWrapper style={{ minHeight: 'auto' }}>
          <Paragraph>
            Thank you for choosing TELUS Business Cybersecurity.
          </Paragraph>
          <br />
          <Paragraph>
            If you have questions about your TELUS Cybersecurity solution,
            please contact your Account Manager.
          </Paragraph>
        </ContentWrapper>
      </div>
    </>
  );
};

export default Success;
